import styled from 'styled-components';
import { Row, Col, Divider } from 'antd';
import { Common, device, color } from '@stockbit/ui';

const { Modal, Flex, Text } = Common;

const RegisterModal = styled(Modal)`
  font-size: 20px;
  @media (min-width: 600px) {
    border-radius: 6px;
  }
  @media ${device.laptop} {
    &.left-content img {
      width: 400px;
    }
  }
`;

const Container = styled(Col)`
  @media (min-width: 600px) {
    padding: 17% 10% 0 10%;
  }
  @media ${device.laptop} {
    padding: 20% 10% 0 10%;
  }
`;

const TitleBanner = styled(Col)`
  width: 100%;
  position: absolute;
  text-align: center;
  top: 30px;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  div.title-banner {
    color: #066c46;
    font-size: 20px;
    margin-bottom: 8px;
    font-family: ProximaNovaBd;
  }
  p {
    color: #066c46;
    font-size: 13px;
    margin-bottom: 0;
  }

  @media (min-width: 600px) {
    top: 76px;
    div.title-banner {
      font-size: 19.6px;
    }
    p {
      font-size: 11.2px;
    }
  }

  @media ${device.laptop} {
    top: 109px;
    div.title-banner {
      font-size: 28px;
    }
    p {
      font-size: 16px;
    }
  }
`;

const CustomText = styled(Text)`
  @media (min-width: 600px) {
    font-size: 9.8px;
  }
  @media ${device.laptop} {
    font-size: 14px;
  }
`;

const ColEmailButton = styled(Col)`
  padding: 5%;
  border-top: 1px solid ${color.downgray};
`;

const RowRegisterForm = styled(Row)`
  height: 100%;
`;

const LogoContainer = styled(Flex)`
  img {
    width: 66.51px;
    height: 25.7px;
  }
  @media ${device.laptop} {
    img {
      width: 95.02px;
      height: 36.72px;
    }
  }
`;

const TitleForm = styled.div`
  margin: 0;
  font-size: 19.6px;
  font-family: ProximaNovaBd;
  @media ${device.laptop} {
    font-size: 28px;
  }
`;

const DividerText = styled(Divider)`
  margin: 10% 0 !important;
  padding: 0 30px !important;
`;

const Footer = styled(Flex)`
  align-items: center;
  justify-content: center;
  width: 100%;
  border-top: 1px solid ${color.downgray};
`;

export {
  RegisterModal,
  Container,
  TitleBanner,
  Footer,
  CustomText,
  ColEmailButton,
  RowRegisterForm,
  LogoContainer,
  TitleForm,
  DividerText,
};
